module.exports = __webpack_public_path__ + "static/media/ini3-90w.3563c05a.jpg";